import cn from "classnames";
import React, { startTransition, useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { TooltipFMEConstants } from "./constants";
import useTooltipPosition from "./hooks/useTooltipPosition";
import TooltipFMEManager from "./manager";

const DEFAULT_PLACEMENT = "top";

const TooltipFMEContainer = () => {
    const tooltipRef = useRef();

    const [visible, setVisible] = useState(false);
    const [overlay, setOverlay] = useState(null);
    const [className, setClassName] = useState("");
    const [placement, setPlacement] = useState(DEFAULT_PLACEMENT);
    const [, setTimeoutId] = useState(null);

    const [x, y, calcPlacement, arrowStyle] = useTooltipPosition(tooltipRef, placement);

    const tooltipProps = {
        className: `tooltip-fme ${className}`,
        style: visible ? { transform: `translate(${x}px, ${y}px)`, ...arrowStyle } : null,
    };

    useEffect(() => {
        TooltipFMEManager.addCallback(handle);
        return () => {
            TooltipFMEManager.removeCallback();
        };
    }, []);

    const handle = useCallback(({ event, overlay, placement, className = "", timeout = 0 }) => {
        setTimeoutId(clearTimeout);
        placement && setPlacement(placement);
        if (event === TooltipFMEConstants.ENTER) {
            setTimeoutId(
                setTimeout(() => {
                    setOverlay(overlay);
                    setClassName(className);
                    startTransition(() => {
                        setVisible(true);
                    });
                }, timeout),
            );
        } else if (event === TooltipFMEConstants.LEAVE) {
            setVisible(false);
            setClassName("");
            setOverlay(null);
        }
    }, []);

    return createPortal(
        <div ref={tooltipRef} {...tooltipProps}>
            {overlay && (
                <div
                    className={cn(`tooltip-fme__content tooltip-fme__arrow--${calcPlacement}`, {
                        "tooltip-fme__content--visible": visible,
                    })}
                >
                    {overlay}
                </div>
            )}
        </div>,
        document.body,
    );
};

export default TooltipFMEContainer;
